import { Output, Input, Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import {FileSelectEvent, FileUpload, FileUploadHandlerEvent } from 'primeng/fileupload';
import { acceptedUploadTypes } from '@common/file-upload/file-uploads';

@Component({
  selector: 'mojo-additional-docs',
  templateUrl: './additional-docs.component.html'
})
export class AdditionalDocsComponent implements OnInit {

  @Input()
  maxFileSizeInBytes = 52428800;

  @Input()
  acceptedFiles = acceptedUploadTypes().join(',');

  @Input() invalidFileTypeMessage: string;
  @Input() invalidFileTypeMessageDetail = '';


  @Input() files: File[] = [];

  @Input() chooseLabel = 'Upload';

  @Output() upload = new EventEmitter<File[]>();

  @Output() deleteUpload = new EventEmitter<File>();

  @ViewChild('fileUploader') fileUploader: FileUpload;

  constructor() {

  }


  reset() {
    this.files = [];
    this.fileUploader.clear();
  }

  ngOnInit() {
    this.invalidFileTypeMessage = `Invalid file type, supported types: ${this.acceptedFiles}`;
  }

  uploadHandler(event: FileUploadHandlerEvent) {
    this.files.push(...event.files);
    this.upload.emit(event.files);
    this.fileUploader.clear();
  }

  /*
   * Workaround for PrimeNG https://github.com/primefaces/primeng/issues/15212
   */
  onSelect(event : FileSelectEvent) {
    this.uploadHandler(<FileUploadHandlerEvent>{
      files: event.files
    });
  }

  onDeleteFile(file: File) {
    const index = this.files.indexOf(file, 0);
    if (index > -1) {
      this.files.splice(index, 1);
      this.deleteUpload.emit(file);
    }
  }

  hasFiles(): boolean {
    return this.files && this.files.length > 0;
  }

}
